<template>
    <section class="section testimonial-er testimonial-three position-relative">
        <div class="testimonial__text-slider">
            <div class="swiper-wrapper">
                <div class="testimonial__text-slider-single swiper-slide">
                    <span></span>
                    <h2 class="h1">
                        <a href="javascript:void(0)">
                            client's testimonial
                            <i class="fa-sharp fa-solid fa-arrow-down-right"></i>
                        </a>
                    </h2>
                </div>
                <div class="testimonial__text-slider-single swiper-slide">
                    <span></span>
                    <h2 class="h1">
                        <a href="javascript:void(0)">
                            client's testimonial
                            <i class="fa-sharp fa-solid fa-arrow-down-right"></i>
                        </a>
                    </h2>
                </div>
                <div class="testimonial__text-slider-single swiper-slide">
                    <span></span>
                    <h2 class="h1">
                        <a href="javascript:void(0)">
                            client's testimonial
                            <i class="fa-sharp fa-solid fa-arrow-down-right"></i>
                        </a>
                    </h2>
                </div>
                <div class="testimonial__text-slider-single swiper-slide">
                    <span></span>
                    <h2 class="h1">
                        <a href="javascript:void(0)">
                            client's testimonial
                            <i class="fa-sharp fa-solid fa-arrow-down-right"></i>
                        </a>
                    </h2>
                </div>
                <div class="testimonial__text-slider-single swiper-slide">
                    <span></span>
                    <h2 class="h1">
                        <a href="javascript:void(0)">
                            client's testimonial
                            <i class="fa-sharp fa-solid fa-arrow-down-right"></i>
                        </a>
                    </h2>
                </div>
                <div class="testimonial__text-slider-single swiper-slide">
                    <span></span>
                    <h2 class="h1">
                        <a href="javascript:void(0)">
                            client's testimonial
                            <i class="fa-sharp fa-solid fa-arrow-down-right"></i>
                        </a>
                    </h2>
                </div>
                <div class="testimonial__text-slider-single swiper-slide">
                    <span></span>
                    <h2 class="h1">
                        <a href="javascript:void(0)">
                            client's testimonial
                            <i class="fa-sharp fa-solid fa-arrow-down-right"></i>
                        </a>
                    </h2>
                </div>
            </div>
        </div>
        <div class="container position-relative">
            <div class="row">
                <div class="col-12 col-xxl-10">
                    <div class="testimonial-s__slider">
                        <div class="swiper-wrapper">
                            <div class="testimonial-s__slider-single swiper-slide">
                                <div class="row items-gap align-items-center">
                                    <div class="col-12 col-lg-4 col-xxl-4">
                                        <div class="thumb">
                                            <img :src="require('@/assets/images/testimonial/s-thumb.png')" alt="Image">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="44" height="322"
                                                viewBox="0 0 44 322" fill="none">
                                                <path d="M43 -0.000976562V151.999L2 192.999H43V321.999"
                                                    stroke="#D9D9D9" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-7 offset-lg-1 col-xxl-7 offset-xxl-1">
                                        <div class="testimonial-s__content">
                                            <div class="quote">
                                                <i class="fa-solid fa-quote-right"></i>
                                            </div>
                                            <div class="content">
                                                <h4>posuere luctus orci. Donec vitae mattis quam, vitae tempor arcu.
                                                    Aenean
                                                    non odio porttitor, convallis erat sit amet, facilisis velit. Nulla
                                                    ornare convallis malesuada. Phasellus molestie, ipsum ac fringilla.
                                                </h4>
                                            </div>
                                            <div class="content-cta">
                                                <h5>Daniel Smith</h5>
                                                <p>Senior engineer</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="testimonial-s__slider-single swiper-slide">
                                <div class="row items-gap align-items-center">
                                    <div class="col-12 col-lg-4 col-xxl-4">
                                        <div class="thumb">
                                            <img :src="require('@/assets/images/testimonial/s-thumb-two.png')"
                                                alt="Image">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="44" height="322"
                                                viewBox="0 0 44 322" fill="none">
                                                <path d="M43 -0.000976562V151.999L2 192.999H43V321.999"
                                                    stroke="#D9D9D9" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-7 offset-lg-1 col-xxl-7 offset-xxl-1">
                                        <div class="testimonial-s__content">
                                            <div class="quote">
                                                <i class="fa-solid fa-quote-right"></i>
                                            </div>
                                            <div class="content">
                                                <h4>posuere luctus orci. Donec vitae mattis quam, vitae tempor arcu.
                                                    Aenean
                                                    non odio porttitor, convallis erat sit amet, facilisis velit. Nulla
                                                    ornare convallis malesuada. Phasellus molestie, ipsum ac fringilla.
                                                </h4>
                                            </div>
                                            <div class="content-cta">
                                                <h5>Daniel Smith</h5>
                                                <p>Senior engineer</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="testimonial-s__slider-single swiper-slide">
                                <div class="row items-gap align-items-center">
                                    <div class="col-12 col-lg-4 col-xxl-4">
                                        <div class="thumb">
                                            <img :src="require('@/assets/images/testimonial/s-thumb-three.png')"
                                                alt="Image">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="44" height="322"
                                                viewBox="0 0 44 322" fill="none">
                                                <path d="M43 -0.000976562V151.999L2 192.999H43V321.999"
                                                    stroke="#D9D9D9" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="col-12 col-lg-7 offset-lg-1 col-xxl-7 offset-xxl-1">
                                        <div class="testimonial-s__content">
                                            <div class="quote">
                                                <i class="fa-solid fa-quote-right"></i>
                                            </div>
                                            <div class="content">
                                                <h4>posuere luctus orci. Donec vitae mattis quam, vitae tempor arcu.
                                                    Aenean
                                                    non odio porttitor, convallis erat sit amet, facilisis velit. Nulla
                                                    ornare convallis malesuada. Phasellus molestie, ipsum ac fringilla.
                                                </h4>
                                            </div>
                                            <div class="content-cta">
                                                <h5>Daniel Smith</h5>
                                                <p>Senior engineer</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="slide-group justify-content-start">
                <button aria-label="previous item" class="slide-btn prev-testimonial-three">
                    <i class="fa-solid fa-angle-left"></i>
                </button>
                <button aria-label="next item" class="slide-btn next-testimonial-three">
                    <i class="fa-solid fa-angle-right"></i>
                </button>
            </div>
        </div>
        <div class="other-section">
            <img class="other-section-image" src="" alt="Next Slide Image">
        </div>
    </section>
</template>

<script>
    import Swiper from 'swiper';
    import 'swiper/swiper-bundle.css';

    export default {
        name: "Testimonial",
        mounted() {
            const textSlider = new Swiper('.testimonial__text-slider', {
                slidesPerView: 'auto',
                slidesPerGroup: 10,
                loop: true,
                speed: 100000,
                easing: 'linear',
                autoplay: {
                    delay: 0,
                },
            });

            const testimonialSlider = new Swiper('.testimonial-s__slider', {
                slidesPerView: 'auto',
                spaceBetween: 30,
                loop: true,
                speed: 1000,
                autoplay: {
                    delay: 4000,
                },
                navigation: {
                    nextEl: '.next-testimonial-three',
                    prevEl: '.prev-testimonial-three',
                },
            });

            testimonialSlider.on('slideChange', () => {
                // Perform your action on slide change here
                console.log('Slide changed! Do something...');
                const nextIndex = testimonialSlider.activeIndex + 1;
                const nextSlide = testimonialSlider.slides[nextIndex];
                if (nextSlide) {
                    const nextImage = nextSlide.querySelector('img');
                    if (nextImage) {
                        const nextSlideImage = nextImage.src;
                        const otherSectionImage = document.querySelector('.other-section-image')
                        otherSectionImage.src = nextSlideImage
                    }
                }
            });
        },
    }
</script>

<style>
    .home-eight .testimonial-er .testimonial__text-slider-single {
        width: auto;
    }

    .testimonial-s__slider {
        overflow: hidden;
    }
</style>


// WEBPACK FOOTER //
// src/components/page_components/home-8/Testimonial.vue